import { NewsLabel } from "/@/types/news.d";

export function labelTranslater(label: NewsLabel) {
  switch (label) {
    case "announce":
      return "アナウンス";
    //case "member_announce":
    //  return "会員向けアナウンス";
    case "open_lecture":
      return "公開講座";
    case "training":
      return "研修会";
  }
}

if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest;

  it("labelTranslater", () => {
    expect(labelTranslater("announce")).toBe("アナウンス");
    expect(labelTranslater("open_lecture")).toBe("公開講座");
    expect(labelTranslater("training")).toBe("研修会");
    //expect(labelTranslater("member_announce")).toBe("会員向けアナウンス");
  });
}
